import { Component, Inject, Injectable } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'app-custom-notification',
  templateUrl: './custom-notification.component.html',
  styleUrls: ['./custom-notification.component.css']
})
export class CustomNotificationComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    private snackBarRef: MatSnackBarRef<CustomNotificationComponent>
  ) { }

  get message(): string {
    return this.data.message;
  }

  get showIcon(): boolean {
    return this.data.showError;
  }


  dismiss(): void {
    this.snackBarRef.dismiss();
  }
}


@Injectable({
  providedIn: 'root'
})
export class CustomSnackbarService {

  constructor(private snackBar: MatSnackBar) { }

  openCustomSnackbar(message: string, duration: number = 300000000, showError: boolean = false): void {
    this.snackBar.openFromComponent(CustomNotificationComponent, {
      duration,
      data: { message, showError },
      horizontalPosition: 'center',
      verticalPosition: 'bottom'
    });
  }
}
